import React from 'react';
import Account from '@material-ui/icons/AccountCircleOutlined';
import AssignmentInd from '@material-ui/icons/AssignmentIndOutlined';
import Person from '@material-ui/icons/PersonOutlined';

interface IUserIconProps {
	type?: types.users.userType;
}

const UserIcon = ({ type }: IUserIconProps) => {
	switch (type) {
		case 'ADMIN':
			return <Person />;
		case 'MANAGER':
			return <AssignmentInd />;
		default:
			return <Account />;
	}
};

export default UserIcon;
